'use strict';
import get from 'lodash/get';
import {IONIC_VIEW_ENTER, IONIC_VIEW_LEAVE, SCOPE_DESTROY} from '../../config/constants/view-events';
import {getId} from '../../core-utilities/domain/ReduxUtils';
import {ButtonState} from '../../core-utilities/enums/ButtonState';
import {requestToButtonState} from '../../core-utilities/redux-request/utils';
import {eventToObservable} from '../../core-utilities/rx-utils';
import {getAuthProfile, getResetPassword} from '../../auth/reducers/state';
import {resetPasswordRequest} from '../../auth/redux/resetPassword';

AppSettingsController.$inject = [
  '$scope',
  '$toast',
  '$settings',
  'mobilePushService',
  'DeviceServices',
  'AuthService',
  '$ngRedux',
  'APP_ENV',
];

export function AppSettingsController(
  $scope,
  $toast,
  $settings,
  mobilePushService,
  DeviceServices,
  AuthService,
  $ngRedux,
  APP_ENV,
) {
  $scope.vm = {};
  $scope.CLIENT_VERSION = APP_ENV.CLIENT_VERSION;
  $scope.settings = $settings;
  $scope.ButtonState = ButtonState;

  $scope.cameraResolutions = $settings.cameraResolutions;

  $scope.showMobileSettings = DeviceServices.isWebView();
  // This setting is only needed on Android currently.
  $scope.showOrientationMode = DeviceServices.getDeviceType() === DeviceServices.DEVICE_TYPES.ANDROID;

  $scope.vidQualities = $settings.vidQualities;

  $scope.updateEmail = updateEmail;
  $scope.updatePush = updatePush;
  $scope.logout = AuthService.logout;
  $scope.changePassword = changePassword;
  $scope.showPasswordButton = showPasswordButton;

  getEmailNotificationsSettings();
  init();

  $scope.displayUploadsSection = true;

  /*****************************************************************************************************************
   * Header Buttons
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Context Menu Actions
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function updateEmail(useEmail) {
    return AuthService.getCurrentUser()
      .then((user) => user.updateEmailNotifications(useEmail))
      .catch((e) => $toast.showMessage('Failed to update settings', null, $toast.TOAST_TYPES.error))
      .finally(getEmailNotificationsSettings);
  }

  function updatePush(usePush) {
    return AuthService.getCurrentUser()
      .then(user => usePush ? mobilePushService.enablePush(getId(user)) : mobilePushService.disablePush(getId(user)))
      .catch(e => $settings.enablePushNotifications = !usePush);
  }

  // Authentication actions

  function changePassword() {
    // click change password button
    const profile = getAuthProfile($ngRedux.getState());
    if (profile) {
      $ngRedux.dispatch(resetPasswordRequest.actions.sendRequest({email: profile.email}));
    } else {
      // TODO: this shouldn't happen, but we can retrieve it

    }
  }

  // TODO: add support for changing language. Afterwards run $ionicHistory.clearCache();


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

  function getEmailNotificationsSettings() {
    return AuthService.getCurrentUser()
      .then((user) => user.$getPreferences())
      .then((prefs) => {
        $scope.vm.enableEmailNotifications = get(prefs || {}, 'notifications.email.enabled');
      })
      .catch((e) => {
        console.error(e);
      });
  }

  function showPasswordButton() {
    return !$scope.isSocial
      && !$scope.passwordState.isFetching
      && !$scope.passwordState.showSuccess
      && !$scope.passwordState.err
    ;
  }


  /*****************************************************************************************************************
   * Initialization
   ****************************************************************************************************************/

  /**
   * Bind to the store
   */
  function init() {
    const profile = getAuthProfile($ngRedux.getState());
    $scope.isSocial = get(profile, 'identities[0].isSocial');
    $scope.passwordState = {};

    eventToObservable($scope, IONIC_VIEW_ENTER)
      .startWith(null)
      .takeUntil(eventToObservable($scope, SCOPE_DESTROY)) // guarantee cleanup
      .mergeMap(() =>
        $ngRedux.state$
          .takeUntil(eventToObservable($scope, IONIC_VIEW_LEAVE))
          .map(getResetPassword)
          .map(requestToButtonState)
          .distinctUntilChanged()
      )
      .subscribe(resetPasswordMode =>
        $scope.$evalAsync(() => {
          $scope.resetPasswordMode = resetPasswordMode;
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/js/settings/controllers/AppSettingsController.js